(function () {
	/** Copy site switcher into mobile drawer once at load. One source in DOM; clone for mobile. Visibility handled by CSS. */
	function copySiteSwitcherToMobile() {
		const slot = document.getElementById("site-switcher-mobile-slot");
		const source = document.querySelector(".site-switcher-desktop .site-switcher");
		if (!slot || !source || slot.querySelector(".site-switcher")) return;
		const clone = source.cloneNode(true);
		clone.setAttribute("aria-hidden", "false");
		slot.appendChild(clone);
	}

	const headerMobile = () => {
		copySiteSwitcherToMobile();

		const headerSection = document.querySelector(".header-mobile-section");
		const header = document.querySelector(".header-mobile");
		let scrollPos = 0;
		window.addEventListener("scroll", () => {
			if (!header.classList.contains("sticky-header")) {
				return;
			}
			const scroll = window.scrollY;
			if (scroll > scrollPos) {
				// down
				if (scroll > 100) {
					hideHeader();
				} else {
					showHeader();
				}
			} else {
				// up
				showHeader();
			}
			scrollPos = scroll;
		});
		function hideHeader() {
			if (header.classList.contains("sticky-header-always")) {
				return "";
			}
			headerSection.classList.add("hide");
		}
		function showHeader() {
			headerSection.classList.remove("hide");
		}

		const burger = document.querySelector(".header-mobile__burger");
        const mobileCloser = document.getElementById('mobile-header-close');
		const mobileMenu = document.querySelector(".header-mobile__menu");
		const mobileAnimateBg = document.querySelector(".animate-bg");
		burger.addEventListener("click", function (e) {
			e.preventDefault();
			burger.classList.toggle("active");
			mobileMenu.classList.toggle("active");
			mobileAnimateBg.classList.toggle("active");
			document.body.classList.toggle("overflow-hidden");
		});

        mobileCloser.addEventListener("click", function (e) {
			e.preventDefault();
			burger.classList.remove("active");
			mobileMenu.classList.remove("active");
			mobileAnimateBg.classList.remove("active");
			document.body.classList.remove("overflow-hidden");
		});

		const mobileMenuList = document.querySelectorAll(
			".header-mobile__menu-header a"
		);
		mobileMenuList.forEach((item) => {
			item.addEventListener("click", function (event) {
				event.preventDefault();
				const id = this.getAttribute("href");
				mobileMenuList.forEach((_item) => {
					_item.parentElement.classList.remove("active");
				});
				this.parentElement.classList.add("active");
				const menus = document.querySelectorAll(".header-mobile__menus > li");
				const current = document.querySelector(id);
				console.log(current);
				menus.forEach((_menu) => {
					_menu.style.display = "none";
				});
				current.style.display = "block";
			});
		});
	};

	document.addEventListener("shopify:section:load", headerMobile);
	headerMobile();
})();
